import { NHS_LENGTH } from './commonConstants';

const NHS_MOD = 11;

export const nhsNumberChecksum = (value) => {
    value = value.replace(/\s/g, '');

    let sum = 0;
    for (let i = 0; i < value.length - 1; i++) sum += value[i] * (NHS_LENGTH - i);

    let total = NHS_MOD - (sum % NHS_MOD);
    if (total === NHS_MOD) total = 0;

    const checkDigit = total < NHS_LENGTH ? parseInt(value[NHS_LENGTH - 1]) : 0;

    return !(total === NHS_LENGTH || total !== checkDigit);
};
